import * as React from "react";
import PropTypes from "prop-types";

import "./styles.css";

const Icon = ({ value, iconName }) => (
  <>
    {value && (
      <span styleName="icon">
        <i className={`fa fa-${iconName}`} aria-hidden="true" />
        <span>{value}</span>
      </span>
    )}
  </>
);

Icon.propTypes = {
  value: PropTypes.string,
  iconName: PropTypes.string.isRequired
};

export default Icon;
